var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreenStatusCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M9 13.5C11.4825 13.5 13.5 11.4825 13.5 9C13.5 6.5175 11.4825 4.5 9 4.5C6.5175 4.5 4.5 6.5175 4.5 9C4.5 11.4825 6.5175 13.5 9 13.5Z",
    fill: "#34A853"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 15C12.315 15 15 12.315 15 9C15 5.685 12.315 3 9 3C5.685 3 3 5.685 3 9C3 12.315 5.685 15 9 15ZM9 4.5C11.4825 4.5 13.5 6.5175 13.5 9C13.5 11.4825 11.4825 13.5 9 13.5C6.5175 13.5 4.5 11.4825 4.5 9C4.5 6.5175 6.5175 4.5 9 4.5Z",
    fill: "#34A853"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenStatusCircle);
export default __webpack_public_path__ + "static/media/green_status_circle.ea6a4e200f7e6f626ee5307c05e3eb65.svg";
export { ForwardRef as ReactComponent };